import React, { useState } from "react";
import Header from "../Registration/Header";
import user from "../../Constant/Icons/user.svg";
import axios from "axios";
import passwordIcon from "../../Constant/Icons/password.svg";
import Incorrect from "./../../Constant/Icons/Incorrect.svg";
import correct from "./../../Constant/Icons/correct.svg";
import eyeIcon from "../../Constant/Icons/eye.svg";
import eyeSlashIcon from "../../Constant/Icons/eyehide.svg";
import warningIcon from "./../../Constant/Icons/warning.svg";
import PopModal from "../../Constant/Custom/Models/PopModal";
import { serverUrl } from "../../Constant/Static/config";
import Loader from '../../Constant/Custom/Loader';
import '../Registration/Login.css';


function ForgetPassword() {
  const [formData, setFormData] = useState({
    email: { value: "", isValid: true },
    mobile: { value: "", isValid: true },
    password: { value: "", isValid: true },
    confirm_password: { value: "", isValid: true },
    onetimepass: { value: "", isValid: true },
  });

  const regex = {
    mobile: /^[6-9]\d{9}$/,
    email: /^(?=.*[a-zA-Z0-9._%+-]+@(?:gmail|yahoo)\.com$).*$/,
  };

  const [passwordCheck, setPasswordCheck] = useState({
    lengthCheck: { pattern: 7, isValid: false },
    numberCheck: { pattern: /.*[0-9].*/, isValid: false },
    lowercaseCheck: { pattern: /.*[a-z].*/, isValid: false },
    uppercaseCheck: { pattern: /.*[A-Z].*/, isValid: false },
    specialCharCheck: {
      pattern: /.*[!@#$%^&*()_+-=[\]{};':"\\|,.<>/?].*/,
      isValid: false,
    },
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [isFielderror, setIsfielderror] = useState(true);
  const [isSendingOTP, setIsSendingOTP] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [resendTimer, setResendTimer] = useState(200);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const [isLoading, setIsLoading] = useState(false);

  const onRegister = () => {
    window.location.href = '/login';
  }

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const setDefaultForm = (e) => {
    setFormData({
      email: { value: '', isValid: true },
      mobile: { value: '', isValid: true },
      password: { value: '', isValid: true },
      confirm_password: { value: '', isValid: true },
      onetimepass: { value: '', isValid: true },
    });
  };

  const handlePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };


  const validateField = (name, value) => {
    let isValid = false;
    if (name === "email" && regex.email.test(value.trim())) {
      isValid = true;
      // console.log("Valid");
    }
    if (name === "mobile" && regex.mobile.test(value.trim())) {
      isValid = true;
      // console.log("Valid");
    }
    if (name === "confirm_password") {
      isValid = value.trim() === formData.password.value.trim();
    }
    return isValid;
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    let isValid = false;

    if (name === 'password') {
      const isValidLength = value.trim().length >= 7;
      const containsNumber = /\d/.test(value.trim());
      const containsLowercase = /[a-z]/.test(value.trim());
      const containsUppercase = /[A-Z]/.test(value.trim());
      const containsSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(value.trim());

      setPasswordCheck({
        ...passwordCheck,
        lengthCheck: { ...passwordCheck.lengthCheck, isValid: isValidLength },
        numberCheck: { ...passwordCheck.numberCheck, isValid: containsNumber },
        lowercaseCheck: { ...passwordCheck.lowercaseCheck, isValid: containsLowercase },
        uppercaseCheck: { ...passwordCheck.uppercaseCheck, isValid: containsUppercase },
        specialCharCheck: { ...passwordCheck.specialCharCheck, isValid: containsSpecialChar },
      });

      isValid = isValidLength && containsNumber && containsLowercase && containsUppercase && containsSpecialChar;
    }
    else {
      if (name === "email") {
        isValid = formData.email.isValid;
        // console.log("Valid");
      }
      if (name === "mobile") {
        isValid = formData.mobile.isValid;
        // // console.log("Valid");
      }
      if (name === 'confirm_password') {
        isValid = formData.confirm_password.isValid;
      }
      if (!isValid) {
        isValid = validateField(name, value)
      }
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: { value, isValid },
    }));
    if (Object.values(formData).every((field) => field.isValid)) {
      setIsfielderror(false);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const isValid = validateField(name, value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: { value, isValid },
    }));
    if (Object.values(formData).every((field) => field.isValid)) {
      setIsfielderror(false);
    }
  }

  const handleSendOTP = async () => {
    // console.log(formData.email);

    const isFormValid = Object.values(formData).every((field) => field.isValid);

    if (!isFormValid) {
      setIsSendingOTP(false);
      // console.log("Form is not valid");
      return;
    }
    try {
      setIsLoading(true);
      const validUser = await axios.post(`${serverUrl}/api/verifyUser`, {
        mobile: formData.mobile.value.trim(),
        email: formData.email.value.trim(),
        table: "registration"
      });
      // console.log("valid user", validUser);
      if (validUser.status === 200) {
        setIsSendingOTP(true);
        if (formData.mobile.value.length === 10) {
          // console.log(formData.mobile.value);
          try {
            // Send OTP via API call
            const response = await axios.post(`${serverUrl}/api/send-otp`, {
              mobile: formData.mobile.value.trim(),
              email: formData.email.value.trim(),
            });
            // console.log(response);
            if (response.status === 200) {
              setModalType({
                icon: "success",
                title: "Success",
                text: response.data.message,
              });
              openModal();
              setOnConfirm(() => closeModal);
            }
            setIsOtpSent(true);
            const interval = setInterval(() => {
              setResendTimer((prev) => {
                if (prev <= 0) {
                  clearInterval(interval);
                  setIsSendingOTP(false);
                  setIsOtpSent(false);
                  return 200;
                }
                return prev - 1;
              });
            }, 1000);
          } catch (error) {
            setModalType({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
            openModal();
            setOnConfirm(() => closeModal);
            console.error("Error sending OTP:", error);
          } finally {
            setIsSendingOTP(false);
          }
        }
      }
    } catch (err) {
      // console.log("verify user error", err);
      if (err.response.status === 400) {
        // console.log("inalid user");

        setModalType({
          icon: "error",
          title: "Invalid",
          text: err.response.data.message,
        });
        openModal();
        setDefaultForm();
        setOnConfirm(() => closeModal);
      }
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    if (!formData.onetimepass.value) {
      setModalType({
        icon: "warning",
        title: "Warning",
        text: "Please Enter OTP",
      });
      openModal();
      setOnConfirm(() => closeModal);
      return;
    }
    try {
      setIsLoading(true);
      const res = await axios.post(`${serverUrl}/api/verify-otp`, {
        mobile: formData.mobile.value.trim(),
        otp: formData.onetimepass.value.trim(),
      });
      // console.log(res);

      if (res.status === 200) {
        setIsOtpVerified(true);
        formData.onetimepass.isValid = true;
        setModalType({
          icon: "success",
          title: "Success",
          text: "OTP Verified Successfully",
        });
        openModal();
        setOnConfirm(() => closeModal);
        // console.log(res.data);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setModalType({ icon: "warning", title: "Warning", text: "Invalid OTP" });
      openModal();
      setOnConfirm(() => closeModal);
      return;
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(formData);

    const isFormValid = Object.values(formData).every(field => field.isValid);
    if (!isFormValid) {
      // console.log('Form is not valid');
      return;
    }
    const dataToSend = {
      email: formData.email.value.trim(),
      mobile: formData.mobile.value.trim(),
      password: formData.password.value.trim(),
      table: "registration"
    };

    try {
      setIsLoading(true);
      const res = await axios.post(`${serverUrl}/api/forgotPassword`, dataToSend);
      if (res.status === 200) {

        setModalType({ icon: 'success', title: 'Success', text: 'Password Updated successfully!' });
        openModal();
        setOnConfirm(() => onRegister);
        // // console.log(`Registration successful. Your application number is ${res.data.appnumber}`);
        // window.location.href = '/';
      }
      else {
        alert("Something went wrong,Try agin later.");
      }
      // console.log(res.data);
    } catch (err) {
      // Check if the error has a response and if it's a 400 status code
      if (err.response) {
        if (err.response.status === 400) {
          setModalType({ icon: 'warning', title: 'Warning', text: 'Applicant Not Exist.' });
          openModal();
          setOnConfirm(() => closeModal);
          setDefaultForm();
        } else {
          // Handle other error statuses
          setModalType({ icon: 'error', title: 'Error', text: 'An error occurred. Please try again.' });
          openModal();
          setOnConfirm(() => closeModal);
          setDefaultForm();
        }
      } else {
        // Handle network errors or other issues
        setModalType({ icon: 'error', title: 'Error', text: 'An error occurred. Please try again.' });
        openModal();
        setOnConfirm(() => closeModal);
        setDefaultForm();
      }
    }
    finally {
      setIsLoading(false);
    }
  };

  const handleCancel = async () => {
    window.location.reload();
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div
      style={{ width: "100dvw", height: "100dvh", backgroundColor: "#f9f9f9" }}
    >
      <Header>
        <a href="/login">
          <img src={user} alt="Login" width={50} height={50} />
        </a>
      </Header>
      <div>
        <div className="forget-container">
          <div className="forget-content">
            <h2 className="forget-title">Forget Password</h2>
            <form className="forget-form" onSubmit={handleSubmit}>
              {!isOtpVerified ? (
                <>
                  <div className="forget-form-group">
                    <div style={{ width: "100%" }}>
                      <label htmlFor="email" className="forget-form-label">
                        Email ID
                      </label>
                    </div>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email.value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Email Address"
                      className="forget-form-input"
                      required
                    />
                    {!formData.email.isValid && (
                      <div className="forget-error " style={{ width: "100%" }}>
                        <img
                          src={warningIcon}
                          alt="wrong"
                          width={20}
                          height={20}
                        />
                        <span>Enter a valid email ID</span>
                      </div>
                    )}
                  </div>
                  <div className="forget-form-group">
                    <div style={{ width: "100%" }}>
                      <label htmlFor="mobile" className="forget-form-label">
                        Mobile No.
                      </label>
                    </div>
                    <input
                      type="text"
                      id="mobile"
                      name="mobile"
                      value={formData.mobile.value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Enter Mobile Number"
                      className="forget-form-input"
                      required
                    />

                    {!formData.mobile.isValid && (
                      <div className="forget-error" style={{ width: "100%" }}>
                        <img
                          src={warningIcon}
                          alt="wrong"
                          width={20}
                          height={20}
                        />
                        <span>Enter valid mobile number</span>
                      </div>
                    )}
                  </div>
                  <div className="">
                    <input
                      className="forget-btn forget-btn-primary"
                      id="sendOtpBtn"
                      type="button"
                      value={isSendingOTP
                        ? "Sending..."
                        : isOtpSent
                          ? `Resend OTP in ${resendTimer}s`
                          : "Send OTP"}
                      disabled={
                        isFielderror ||
                        isSendingOTP ||
                        isOtpSent ||
                        isOtpVerified
                      }
                      style={isFielderror ||
                        isSendingOTP ||
                        isOtpSent ||
                        isOtpVerified ? { cursor: 'not-allowed', backgroundColor: '#808080' } : { cursor: 'pointer' }}
                      onClick={handleSendOTP}
                    >

                    </input>
                    {/* <p>Resend OTP in {resendTimer} seconds</p> */}
                  </div>
                  {isOtpSent && (
                    <div className="forget-form-group">
                      <div className="forget-form-label">
                        <label>Enter OTP</label>
                      </div>
                      <input
                        type="text"
                        className="forget-form-input"
                        name="onetimepass"
                        value={formData.onetimepass.value}
                        onChange={handleChange}
                        placeholder="Enter OTP"
                        disabled={isOtpVerified}
                        required
                      />
                      <div className="">
                        <button
                          className="forget-btn forget-btn-primary"
                          type="button"
                          onClick={handleVerifyOtp}
                          style={isOtpVerified ? { cursor: 'not-allowed', backgroundColor: '#808080' } : { cursor: 'pointer' }}
                        >
                          Verify OTP
                        </button>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {/* <div className='forget-form-group'>
                                        <div style={{ width: '100%' }}>
                                            <label htmlFor='email' className='forget-form-label'>Email ID</label>
                                        </div>
                                        <input type='email' id='email' name='email' value={formData.email.value} onChange={handleChange} placeholder='Enter Email Address' className='forget-form-input' required/>
                                        {!formData.email.isValid && (
                                            <div className='forget-error ' style={{ width: '100%' }}>
                                                <img src={warningIcon} alt='wrong' width={20} height={20} />
                                                <span>Enter a valid email ID</span>
                                            </div>
                                        )}
                                    </div>
                                    <div className='forget-form-group'>
                                        <div style={{ width: '100%' }}>
                                            <label htmlFor='mobile' className='forget-form-label'>Mobile No.</label>
                                        </div>
                                        <input type='text' id='mobile' name='mobile' value={formData.mobile.value} onChange={handleChange} placeholder='Enter Mobile Number' className='forget-form-input' required/>
                                 
                                        {!formData.mobile.isValid && (
                                            <div className='forget-error' style={{ width: '100%' }}>
                                                <img src={warningIcon} alt='wrong' width={20} height={20} />
                                                <span>Enter valid mobile number</span>
                                            </div>
                                        )}
                                    </div> */}
                  <div className="forget-form-group">
                    <div className="forget-form-label">
                      <label>New Password</label>
                    </div>

                    <input
                      className="forget-form-input"
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password.value}
                      onChange={handleChange}
                      placeholder="Enter Password"
                      required
                    />

                    {/* <img
                      className="IconForInput"
                      src={passwordIcon}
                      alt="password"
                      width={20}
                      height={20}
                    /> */}

                    <button
                      type="button"
                      className="forgot-toggle-password"
                      onClick={handlePasswordVisibility}
                    >
                      <img
                        src={showPassword ? eyeSlashIcon : eyeIcon}
                        alt="toggle password visibility"
                        width={20}
                        height={20}
                      />
                    </button>
                  </div>
                  {!formData.password.isValid && (
                    <div className="forgot-password-error">
                      <ul>
                        <li>
                          <img
                            src={
                              passwordCheck.lengthCheck.isValid
                                ? correct
                                : Incorrect
                            }
                            alt="wrong"
                            width={15}
                            height={15}
                          />
                          Password length should be greater than or equal to 7.
                        </li>
                        <li>
                          <img
                            src={
                              passwordCheck.uppercaseCheck.isValid
                                ? correct
                                : Incorrect
                            }
                            alt="wrong"
                            width={15}
                            height={15}
                          />
                          Password should contain atleast one uppercase
                          character.
                        </li>
                        <li>
                          <img
                            src={
                              passwordCheck.lowercaseCheck.isValid
                                ? correct
                                : Incorrect
                            }
                            alt="wrong"
                            width={15}
                            height={15}
                          />
                          Password should contain atleast one lowercase
                          character.
                        </li>
                        <li>
                          <img
                            src={
                              passwordCheck.specialCharCheck.isValid
                                ? correct
                                : Incorrect
                            }
                            alt="wrong"
                            width={15}
                            height={15}
                          />
                          Password should contain atleast one special character.
                        </li>
                        <li>
                          <img
                            src={
                              passwordCheck.numberCheck.isValid
                                ? correct
                                : Incorrect
                            }
                            alt="wrong"
                            width={15}
                            height={15}
                          />
                          Password should contain atleast one number.
                        </li>
                      </ul>
                    </div>
                  )}

                  <div className="forget-form-group">
                    <div className="forget-form-label">
                      <label>Confirm Password</label>
                    </div>
                    <input
                      className="forget-form-input"
                      type={showConfirmPassword ? "text" : "password"}
                      name="confirm_password"
                      value={formData.confirm_password.value}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder="Confirm Password"
                      required
                    />
                    {/* <img className="IconForInput" src={passwordIcon} alt="user" width={20} height={20} /> */}

                    <button
                      type="button"
                      className="toggle-password"
                      onClick={handleConfirmPasswordVisibility}
                      aria-label={
                        showConfirmPassword ? "Hide Password" : "Show Password"
                      }
                    >
                      <img
                        src={showConfirmPassword ? eyeSlashIcon : eyeIcon}
                        alt="toggle password visibility"
                        width={20}
                        height={20}
                      />
                    </button>
                  </div>
                  {!formData.confirm_password.isValid && (
                    <div className="forgot-password-error">
                      <ul>
                        <li>
                          <img
                            src={Incorrect}
                            alt="wrong"
                            width={15}
                            height={15}
                          />
                          Password doesn't match
                        </li>
                      </ul>
                    </div>
                  )}

                </>
              )}
              <div>
                <input
                  className="forget-btn forget-btn-primary"
                  type="submit"
                  style={!isOtpVerified ? { cursor: 'not-allowed', backgroundColor: '#808080' } : { cursor: 'pointer' }}
                  disabled={!isOtpVerified}
                  value={"Submit"}
                />
              </div>
              {/* <button type='submit' className='forget-btn forget-btn-primary'>Submit</button> */}
            </form>
          </div>
        </div>
        <div>
          <PopModal
            isOpen={isModalOpen}
            onConfirm={onConfirm}
            type={modalType}
            onCancel={handleCancel}
          />
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
